import { FaUser } from "react-icons/fa";
import Doctor from "../../icons/doctor";

const Workspaces = () => {
  const workspaces = [
    {
      logo: "SI",
      name: "Siloam Pharmacy",
      description: `This space has been created by Hidden and you have direct access to the live
        opportunities coming from some of our amazing Creative, PR and Marketing
        clients but you can also network.`,
      meta: {
        totalDoctors: 20,
        totalChannels: 45,
        totalMembers: 100,
      },
    },
    {
      logo: "SI",
      name: "Siloam Pharmacy",
      description: `This space has been created by Hidden and you have direct access to the live
        opportunities coming from some of our amazing Creative, PR and Marketing
        clients but you can also network.`,
      meta: {
        totalDoctors: 20,
        totalChannels: 45,
        totalMembers: 100,
      },
    },
    {
      logo: "SI",
      name: "Siloam Pharmacy",
      description: `This space has been created by Hidden and you have direct access to the live
        opportunities coming from some of our amazing Creative, PR and Marketing
        clients but you can also network.`,
      meta: {
        totalDoctors: 20,
        totalChannels: 45,
        totalMembers: 100,
      },
    },
    {
      logo: "SI",
      name: "Siloam Pharmacy",
      description: `This space has been created by Hidden and you have direct access to the live
        opportunities coming from some of our amazing Creative, PR and Marketing
        clients but you can also network.`,
      meta: {
        totalDoctors: 20,
        totalChannels: 45,
        totalMembers: 100,
      },
    },
  ];
  return (
    <div className="flex flex-col gap-5">
      {workspaces.map((workspace, index) => (
        <div
          style={{ boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25" }}
          key={index}
          className="flex items-start rounded-md"
        >
          <div className="flex border-r-2 p-5 pr-20 object-contain gap-5 items-start">
            <div className="bg-[#b0abab] px-3 py-2 font-bold text-xl text-white rounded-md">
              {workspace.logo}
            </div>
            <div className="flex flex-col gap-1">
              <div className="text-[#124DC1] font-semibold text-xl">
                {workspace.name}
              </div>
              <div className="break-words max-w-[35rem]">
                {workspace.description}
              </div>
            </div>
          </div>
          <div className="flex flex-col p-2 min-w-[13rem] h-full">
            <div className="flex justify-between items-center">
              <Doctor color={"#3961C8"} width={25} />
              <div className="min-w-[calc(100%-40px)]">
                {workspace.meta.totalDoctors}
              </div>
            </div>
            <div className="flex text-[#878787] items-center justify-between">
              <div className="text-2xl font-medium">#</div>
              <div className="min-w-[calc(100%-40px)]">
                {workspace.meta.totalChannels}
              </div>
            </div>
            <div className="flex text-[#878787] items-center justify-between">
              <FaUser />
              <div className="min-w-[calc(100%-40px)]">
                {workspace.meta.totalMembers}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default Workspaces;
